import { readContract, writeContract, waitForTransactionReceipt } from '@wagmi/core';
import { config } from './walletConfig';
import { abi } from './xpct_abi';
import addresses from './addresses';

import utils from '@/composables/utils';
import { JsonRpcProvider, Contract, formatUnits } from 'ethers';
import { queryRecentContractEvents } from './ethService';
const { convertToWei, convertFromWei } = utils;

// ========== 只讀函數 ==========

export async function allowance(owner, spender) {
  return await readContract(config, {
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'allowance',
    args: [owner, spender]
  });
}

export async function balanceOf(account) {
  const balance = await readContract(config, {
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'balanceOf',
    args: [account]
  });
  return convertFromWei(balance, 18, 6);
}

export async function decimals() {
  return await readContract(config, {
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'decimals',
    args: []
  });
}

export async function directorOnly() {
  return await readContract(config, {
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'directorOnly',
    args: []
  });
}

export async function name() {
  return await readContract(config, {
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'name',
    args: []
  });
}

export async function owner() {
  return await readContract(config, {
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'owner',
    args: []
  });
}

export async function paused() {
  return await readContract(config, {
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'paused',
    args: []
  });
}

export async function pctDirector() {
  return await readContract(config, {
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'pctDirector',
    args: []
  });
}

export async function pctToken() {
  return await readContract(config, {
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'pctToken',
    args: []
  });
}

export async function sweepAfter() {
  return await readContract(config, {
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'sweepAfter',
    args: []
  });
}

export async function symbol() {
  return await readContract(config, {
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'symbol',
    args: []
  });
}

export async function totalETHDividendsDistributed() {
  return await readContract(config, {
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'totalETHDividendsDistributed',
    args: []
  });
}

export async function totalSupply() {
  const result = await readContract(config, {
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'totalSupply',
    args: []
  });
  // 假設convertFromWei已經在本文件或全局引入
  return convertFromWei(result, 18,6);
}

export async function totalUSDTDividendsDistributed() {
  return await readContract(config, {
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'totalUSDTDividendsDistributed',
    args: []
  });
}

export async function treasury() {
  return await readContract(config, {
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'treasury',
    args: []
  });
}

export async function usdtToken() {
  return await readContract(config, {
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'usdtToken',
    args: []
  });
}

export async function ethDividendOf(account) {
  return await readContract(config, {
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'ethDividendOf',
    args: [account]
  });
}

export async function usdtDividendOf(account) {
  return await readContract(config, {
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'usdtDividendOf',
    args: [account]
  });
}

export async function accumulativeETHDividendOf(account) {
  return await readContract(config, {
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'accumulativeETHDividendOf',
    args: [account]
  });
}

export async function accumulativeUSDTDividendOf(account) {
  return await readContract(config, {
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'accumulativeUSDTDividendOf',
    args: [account]
  });
}

// ========== 寫入/交易函數 ==========

export async function approve(spender, value) {
  return await writeContract(config, {
    chainId: 137,
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'approve',
    args: [spender, value]
  });
}

export async function setDirectorOnly(enable) {
  return await writeContract(config, {
    chainId: 137,
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'setDirectorOnly',
    args: [enable]
  });
}

export async function stake(amount) {
  return await writeContract(config, {
    chainId: 137,
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'stake',
    args: [amount]
  });
}

export async function unstake(amount) {
  return await writeContract(config, {
    chainId: 137,
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'unstake',
    args: [amount]
  });
}

export async function depositUSDTDividends(amount) {
  return await writeContract(config, {
    chainId: 137,
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'depositUSDTDividends',
    args: [amount]
  });
}

export async function withdrawETHDividend() {
  return await writeContract(config, {
    chainId: 137,
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'withdrawETHDividend',
    args: []
  });
}

export async function withdrawUSDTDividend() {
  return await writeContract(config, {
    chainId: 137,
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'withdrawUSDTDividend',
    args: []
  });
}

export async function setUSDTTokenAddress(usdt) {
  return await writeContract(config, {
    chainId: 137,
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'setUSDTTokenAddress',
    args: [usdt]
  });
}

export async function setPCTTokenAddress(pct) {
  return await writeContract(config, {
    chainId: 137,
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'setPCTTokenAddress',
    args: [pct]
  });
}

export async function extractETH(amount) {
  return await writeContract(config, {
    chainId: 137,
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'extractETH',
    args: [amount]
  });
}

export async function sweepExpiredDividends() {
  return await writeContract(config, {
    chainId: 137,
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'sweepExpiredDividends',
    args: []
  });
}

export async function setTreasury(treasuryAddr) {
  return await writeContract(config, {
    chainId: 137,
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'setTreasury',
    args: [treasuryAddr]
  });
}

export async function pause() {
  return await writeContract(config, {
    chainId: 137,
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'pause',
    args: []
  });
}

export async function unpause() {
  return await writeContract(config, {
    chainId: 137,
    abi,
    address: addresses.xpctContractAddress,
    functionName: 'unpause',
    args: []
  });
}

// 緩存key前綴
const DIVIDEND_RECORDS_CACHE_PREFIX = 'dividendRecordsCache_';
const DIVIDEND_RECORDS_CACHE_TTL = 24 * 60 * 60 * 1000; // 1天（毫秒）

/**
 * 查詢最近N條分紅領取記錄（POL/USDT合併，API 版，帶本地緩存）
 * @param {string} userAddress 用戶地址
 * @param {number} count 條數，默認5
 * @param {boolean} forceRefresh 是否強制刷新（如剛領取完獎勵時設true）
 * @returns {Promise<Array<{amount:string,symbol:string,txHash:string,blockNumber:number,time:string}>>}
 */
export async function fetchDividendRecords(userAddress, count = 5, forceRefresh = false) {
  if (!userAddress) return [];
  const cacheKey = `${DIVIDEND_RECORDS_CACHE_PREFIX}address-filtered-v2_${userAddress.toLowerCase()}_${count}`;
  // 讀取本地緩存
  if (!forceRefresh && typeof window !== 'undefined' && window.localStorage) {
    const cacheStr = window.localStorage.getItem(cacheKey);
    if (cacheStr) {
      try {
        const cacheObj = JSON.parse(cacheStr);
        if (Date.now() - cacheObj.ts < DIVIDEND_RECORDS_CACHE_TTL) {
          return cacheObj.data;
        }
      } catch (e) {}
    }
  }
  try {
    const topic0 = '0xa99261d189cc8bfa1352eb8938b11307a1fee83732180cbac702c01275518977';
    const contractAddress = addresses.xpctContractAddress;
    // 查詢事件
    const logs = await queryRecentContractEvents({
      contractAddress,
      topic0,
      address: userAddress,
      page: 1,
      offset: count,
      chainId: 137, // Polygon主網
    }, count);
    // 解析log數據
    const records = logs.map(log => {
      const data = log.data.startsWith('0x') ? log.data.slice(2) : log.data;
      const amountHex = '0x' + data.slice(0, 64);
      const tokenTypeHex = '0x' + data.slice(64, 128);
      const amountRaw = BigInt(amountHex);
      const tokenType = BigInt(tokenTypeHex).toString();
      let symbol = 'POL';
      let amount = '';
      if (tokenType === '1') {
        symbol = 'USDT';
        amount = Number(formatUnits(amountRaw, 6)).toFixed(2);
      } else {
        symbol = 'POL';
        amount = Number(formatUnits(amountRaw, 18)).toFixed(2);
      }
      let time = null;
      if (log.timeStamp) {
        const timestamp = parseInt(log.timeStamp, 16) * 1000;
        const date = new Date(timestamp);
        const pad = n => n.toString().padStart(2, '0');
        time = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
      }
      return {
        amount,
        symbol,
        txHash: log.transactionHash,
        blockNumber: Number(log.blockNumber),
        time,
        rawAmount: amountRaw.toString(),
      };
    });
    // 寫入本地緩存
    if (typeof window !== 'undefined' && window.localStorage) {
      try {
        window.localStorage.setItem(cacheKey, JSON.stringify({ ts: Date.now(), data: records }));
      } catch (e) {}
    }
    return records;
  } catch (e) {
    console.error('[fetchDividendRecords-API] error:', e);
    throw e;
  }
} 